module.exports = __webpack_public_path__ + "static/media/lttBG.93686926.png";